import { ErrorDisplay } from '@core/components/ErrorDisplay';
import { Button, ButtonType } from '@soteria/design-system-ve';

interface SessionsPageErrorHandlerProps {
  sessionsError: unknown;
  showErrorDialog: boolean;
  onCloseErrorDialog: () => void;
  onRefetch: () => void;
}

interface CommunityNotFoundProps {
  onRefetch: () => void;
}

/**
 * Helper function to handle error retry logic
 */
function handleErrorRetry(sessionsError: unknown, refetch: () => void) {
  const errorWithRetry = sessionsError as { onRetry?: () => void };

  if (errorWithRetry.onRetry) {
    errorWithRetry.onRetry();
  } else {
    refetch();
  }
}

/**
 * Error display component for sessions loading errors
 */
export function SessionsErrorDisplay({ sessionsError, showErrorDialog, onCloseErrorDialog, onRefetch }: SessionsPageErrorHandlerProps) {
  return (
    <ErrorDisplay
      correlationId={(sessionsError as { correlationId?: string }).correlationId}
      isOpen={showErrorDialog}
      message={
        (sessionsError as { message?: string; userMessage?: string }).message ||
        (sessionsError as { message?: string; userMessage?: string }).userMessage ||
        'An unexpected error occurred'
      }
      title="Error Loading Audit Sessions"
      onClose={onCloseErrorDialog}
      onRetry={() => handleErrorRetry(sessionsError, onRefetch)}
    />
  );
}

/**
 * Community not found error state component
 */
export function CommunityNotFound({ onRefetch }: CommunityNotFoundProps) {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '16px',
        minHeight: '400px',
        justifyContent: 'center',
      }}
    >
      <p>Community not found</p>
      <Button buttonType={ButtonType.Secondary} onClick={onRefetch}>
        Retry
      </Button>
    </div>
  );
}
